import { ref } from 'vue'
import { useContentApiLabels, useStoreLabels } from '@common/lib-vue-common'

export const startUpLabels = async () => {
  try {
    const response = await useContentApiLabels()
    const { data } = response
    const labels = ref(data.value?.labels || {})
    console.log('startUpLabels 0', response)
    console.log('startUpLabels 1', data.value)
    console.log('startUpLabels 1b', labels.value)
    useStoreLabels(labels)
    console.log('startUpLabels 2 tridionLabels', globalThis.tridionLabels)
    console.log('startUpLabels 3 tridionLabelsSSR', globalThis.tridionLabelsSSR)
    return labels.value || {}
  } catch (e) {
    console.log(e)
    return {}
  }
}
